import { render, staticRenderFns } from "./SendMessageController.vue?vue&type=template&id=ff71b770&"
import script from "./SendMessageController.vue?vue&type=script&lang=ts&"
export * from "./SendMessageController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports